import store from '@/store/store'

class MarketModule {

  setMarketList(marketList = []) {
    store.commit('MARKET_LIST_SET', marketList)
  }

  getMarketList() {
    return store.state.marketList
  }
}

export default new MarketModule()
